import { MouseEventHandler, ReactNode } from "react";
import { ActionIcon } from "@mantine/core";
import {
  CollapsibleWidthComponent,
  TransitionableComponentProps,
} from "./CollapsibleComponent";

interface CollapsibleActionIconProps {
  isOpen: TransitionableComponentProps["isOpen"];
  children: ReactNode;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  active?: boolean;
}

export const CollapsibleTopMenuActionIcon = ({
  children,
  isOpen,
  disabled,
  onClick,
  active,
}: CollapsibleActionIconProps) => {
  return (
    <CollapsibleWidthComponent height={28} width={28} isOpen={isOpen}>
      <ActionIcon
        variant="light"
        disabled={disabled}
        onClick={onClick}
        sx={(theme, u) => ({
          [u.dark]: {
            color: disabled
              ? undefined
              : active
                ? theme.colors.teal[2]
                : theme.colors.violet[2],
          },
          [u.light]: {
            color: disabled
              ? undefined
              : active
                ? theme.colors.teal[6]
                : theme.colors.violet[7],
          },
        })}
      >
        {children}
      </ActionIcon>
    </CollapsibleWidthComponent>
  );
};
